<template>
    <div>
        <h2>{{ partial.data.title }}</h2>
        <p v-if="partial.data.example" class="example">{{ partial.data.example }}</p>

        <div class="revision" v-for="revision in frozenRevisions">
            <h4 v-if="progress.isRetaking || frozenRevisions.length > 1" class="tag revision__title">{{ revision.title }}</h4>
            <p class="revision__container submission submission--answer">{{ revision.submission }}</p>
        </div>

        <textarea v-if="!readonly" v-model="answer" :class="{ story: partial.data.story }"></textarea>

        <p class="revision__container revision__container--teacher" v-if="readonly && frozenRevisions.length === 0">In te vullen door leerling</p>
    </div>
</template>


<script>
import { setValidation, setSubmission, flushSyncSubmission } from 'js/vuex/actions';
import track from 'js/helpers/analytics';

export default {
    props: {
        partial: {},
        progress: {},
        readonly: {
            type: Boolean,
            default: false,
        }
    },

    vuex: {
        actions: {
            setValidation,
            setSubmission,
        }
    },

    computed: {
        answer: {
            get: function() {
                const sub = this.submissions
                  .filter( s => !s.isFrozen)
                  // newest first
                  .sort( (a,b) => b.updatedAt - a.updatedAt)

                return this.getSubmissionValue( sub[0] )
            },
            set: function(newValue) {
                this.store(newValue)
            }
        },

        submissions: function() {
            return Object.keys(this.$store.state.submissions.storage)
                .map( id => this.$store.state.submissions.storage[id] )
                .filter( submission => submission.progress === this.progress.id && submission.partial === this.partial.id )
        },

        frozenRevisions: function() {
            return this.submissions.filter( s => s.isFrozen )
                .map( s => ({
                    title: 'versie ' + (s.revision + 1),
                    submission: this.getSubmissionValue(s)
                }))
        },

    },
    methods: {
        store: function(value) {

            if ( value == null ) {
                track.exception('Null value answer', { partial: this.partial.id })
                return
            }

            const revision = this.frozenRevisions.length

            this.setSubmission(this.partial, this.progress, revision, value)
                .then( () => this.validate() )
                .catch( err => {
                    track.exception('Can\'t set submission', err, { partial: this.partial.id, data: value })
                })

            this.validate()

        },

        getSubmissionValue: function(submission) {
            if ( submission == null ) {
                return ''
            }
            return typeof submission.data === 'string' ? submission.data : '[ Werk niet herkend ]'
        },

        flush: function() {
            return flushSyncSubmission(this.partial)
        },

        validate: function() {

            const minlength = this.partial.data.minlength == undefined ? 1 : this.partial.data.minlength
            const validated = this.answer.trim().length >=  minlength

            if (validated != this.partial.validated) {
                this.setValidation(this.partial.id, validated)
            }

        }
    },

    created: function() {
        this.validate();
    }
}
</script>


<style lang="scss">

    @import 'global';


</style>



// WEBPACK FOOTER //
// QuestionPartial.vue?248a1682